export const translateStatusFromBrToEn = (status: string) => {
  switch (status) {
    case 'com plano':
      return 'SUBSCRIBER'
    case 'sem plano':
      return 'NON-SUBSCRIBER'
    case 'inativo':
      return 'INACTIVE'
    case 'desconto em folha':
      return 'INVOICED'
    default:
      return status
  }
}
